module.exports = __webpack_public_path__ + "img/pharmacology.54394ea7.svg";